var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "step-content" },
    [
      !_vm.disabled
        ? _c("h5", { staticClass: "mb-3 printable-item" }, [
            _vm._v("Revisão dos Dados")
          ])
        : _c("h5", { staticClass: "mb-3 printable-item" }, [
            _vm._v("CEBAS - Dados da Solicitação de Credenciamento")
          ]),
      !_vm.disabled
        ? _c(
            "b-alert",
            { staticClass: "mb-4", attrs: { variant: "warning", show: "" } },
            [
              _c("div", { staticClass: "alert-body" }, [
                _vm._v(
                  " Revise cuidadosamente todas as informações antes de enviar sua solicitação. "
                )
              ])
            ]
          )
        : _vm._e(),
      _c(
        "b-card",
        {
          staticClass: "mb-3",
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function() {
                return [
                  _c("h6", { staticClass: "mb-0 printable-item" }, [
                    _vm._v("Dados Básicos")
                  ])
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { md: "6" } }, [
                _c("span", { staticClass: "printable-item" }, [
                  _c("strong", [_vm._v("Tipo de Credenciamento:")]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.getCredentialingTypeLabel(
                          _vm.basicData.credentialing_type
                        )
                      )
                  )
                ]),
                _c("br"),
                _c("span", { staticClass: "printable-item" }, [
                  _c("strong", [_vm._v("Área de Atuação:")]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.getActivityAreaLabel(_vm.basicData.activity_area)
                      )
                  )
                ]),
                _c("br"),
                _c("span", { staticClass: "printable-item" }, [
                  _c("strong", [_vm._v("Nome da Entidade:")]),
                  _vm._v(" " + _vm._s(_vm.basicData.entity_name))
                ]),
                _c("br"),
                _c("span", { staticClass: "printable-item" }, [
                  _c("strong", [_vm._v("CNPJ:")]),
                  _vm._v(" " + _vm._s(_vm.basicData.cnpj))
                ]),
                _c("br"),
                _c("span", { staticClass: "printable-item" }, [
                  _c("strong", [_vm._v("CNAE Principal:")]),
                  _vm._v(" " + _vm._s(_vm.basicData.main_cnae))
                ])
              ]),
              _c("b-col", { attrs: { md: "6" } }, [
                _c("span", { staticClass: "printable-item" }, [
                  _c("strong", [_vm._v("E-mail:")]),
                  _vm._v(" " + _vm._s(_vm.basicData.email))
                ]),
                _c("br"),
                _c("span", { staticClass: "printable-item" }, [
                  _c("strong", [_vm._v("Telefone:")]),
                  _vm._v(" " + _vm._s(_vm.basicData.phone))
                ]),
                _c("br"),
                _c("span", { staticClass: "printable-item" }, [
                  _c("strong", [_vm._v("Endereço:")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "whitespace-pre-wrap" }, [
                    _vm._v(_vm._s(_vm.basicData.address))
                  ])
                ])
              ])
            ],
            1
          ),
          _c("hr", { staticClass: "my-3" }),
          _c("div", { staticClass: "legal-representative-section mt-3" }, [
            _c("h6", { staticClass: "text-muted mb-2 printable-item" }, [
              _vm._v("Representante Legal")
            ]),
            _c("p", { staticClass: "mb-1 printable-item" }, [
              _c("strong", [_vm._v("Nome:")]),
              _vm._v(" " + _vm._s(_vm.basicData.legal_representative_name))
            ]),
            _c("p", { staticClass: "mb-1 printable-item" }, [
              _c("strong", [_vm._v("CPF:")]),
              _vm._v(" " + _vm._s(_vm.basicData.legal_representative_cpf))
            ]),
            _c("p", { staticClass: "mb-1 printable-item" }, [
              _c("strong", [_vm._v("Cargo:")]),
              _vm._v(" " + _vm._s(_vm.basicData.legal_representative_position))
            ]),
            _c("p", { staticClass: "mb-0 printable-item" }, [
              _c("strong", [_vm._v("E-mail:")]),
              _vm._v(" " + _vm._s(_vm.basicData.legal_representative_email))
            ])
          ])
        ],
        1
      ),
      _c(
        "b-card",
        {
          staticClass: "mb-3",
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function() {
                return [
                  _c("h6", { staticClass: "mb-0 printable-item" }, [
                    _vm._v("Documentação Jurídica")
                  ])
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _vm.hasJuridicalDocuments
            ? _c("div", [
                _c("ul", { staticClass: "list-unstyled mb-0" }, [
                  _vm.juridicalDocumentation.statute
                    ? _c("li", { staticClass: "mb-2 printable-item" }, [
                        _c("i", {
                          staticClass: "feather icon-file",
                          class: _vm.primaryVariant
                            ? "text-" + _vm.primaryVariant
                            : "text-dynamic-primary"
                        }),
                        _vm.getJuridicalDocumentUrl(
                          _vm.juridicalDocumentation.statute
                        )
                          ? _c(
                              "a",
                              {
                                staticClass: "ml-1 no-print download-link",
                                class: _vm.primaryVariant
                                  ? "text-" + _vm.primaryVariant
                                  : "text-dynamic-primary",
                                attrs: {
                                  href: _vm.getJuridicalDocumentUrl(
                                    _vm.juridicalDocumentation.statute
                                  ),
                                  target: "_blank",
                                  title: "Baixar arquivo"
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "feather icon-download"
                                })
                              ]
                            )
                          : _vm._e(),
                        _c("strong", { staticClass: "ml-2" }, [
                          _vm._v("Estatuto / Ato Constitutivo:")
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getFileName(
                                _vm.juridicalDocumentation.statute
                              )
                            ) +
                            " "
                        ),
                        _vm.getFileSize(_vm.juridicalDocumentation.statute)
                          ? _c("small", { staticClass: "text-muted ml-2" }, [
                              _vm._v(
                                " (" +
                                  _vm._s(
                                    _vm.formatFileSize(
                                      _vm.getFileSize(
                                        _vm.juridicalDocumentation.statute
                                      )
                                    )
                                  ) +
                                  ") "
                              )
                            ])
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm.juridicalDocumentation.election_minutes
                    ? _c("li", { staticClass: "mb-2 printable-item" }, [
                        _c("i", {
                          staticClass: "feather icon-file",
                          class: _vm.primaryVariant
                            ? "text-" + _vm.primaryVariant
                            : "text-dynamic-primary"
                        }),
                        _vm.getJuridicalDocumentUrl(
                          _vm.juridicalDocumentation.election_minutes
                        )
                          ? _c(
                              "a",
                              {
                                staticClass: "ml-1 no-print download-link",
                                class: _vm.primaryVariant
                                  ? "text-" + _vm.primaryVariant
                                  : "text-dynamic-primary",
                                attrs: {
                                  href: _vm.getJuridicalDocumentUrl(
                                    _vm.juridicalDocumentation.election_minutes
                                  ),
                                  target: "_blank",
                                  title: "Baixar arquivo"
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "feather icon-download"
                                })
                              ]
                            )
                          : _vm._e(),
                        _c("strong", { staticClass: "ml-2" }, [
                          _vm._v("Ata de Eleição de Dirigentes:")
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getFileName(
                                _vm.juridicalDocumentation.election_minutes
                              )
                            ) +
                            " "
                        ),
                        _vm.getFileSize(
                          _vm.juridicalDocumentation.election_minutes
                        )
                          ? _c("small", { staticClass: "text-muted ml-2" }, [
                              _vm._v(
                                " (" +
                                  _vm._s(
                                    _vm.formatFileSize(
                                      _vm.getFileSize(
                                        _vm.juridicalDocumentation
                                          .election_minutes
                                      )
                                    )
                                  ) +
                                  ") "
                              )
                            ])
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm.juridicalDocumentation.foundation_document
                    ? _c("li", { staticClass: "mb-2 printable-item" }, [
                        _c("i", {
                          staticClass: "feather icon-file",
                          class: _vm.primaryVariant
                            ? "text-" + _vm.primaryVariant
                            : "text-dynamic-primary"
                        }),
                        _vm.getJuridicalDocumentUrl(
                          _vm.juridicalDocumentation.foundation_document
                        )
                          ? _c(
                              "a",
                              {
                                staticClass: "ml-1 no-print download-link",
                                class: _vm.primaryVariant
                                  ? "text-" + _vm.primaryVariant
                                  : "text-dynamic-primary",
                                attrs: {
                                  href: _vm.getJuridicalDocumentUrl(
                                    _vm.juridicalDocumentation
                                      .foundation_document
                                  ),
                                  target: "_blank",
                                  title: "Baixar arquivo"
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "feather icon-download"
                                })
                              ]
                            )
                          : _vm._e(),
                        _c("strong", { staticClass: "ml-2" }, [
                          _vm._v("Escritura Pública ou Testamento:")
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getFileName(
                                _vm.juridicalDocumentation.foundation_document
                              )
                            ) +
                            " "
                        ),
                        _vm.getFileSize(
                          _vm.juridicalDocumentation.foundation_document
                        )
                          ? _c("small", { staticClass: "text-muted ml-2" }, [
                              _vm._v(
                                " (" +
                                  _vm._s(
                                    _vm.formatFileSize(
                                      _vm.getFileSize(
                                        _vm.juridicalDocumentation
                                          .foundation_document
                                      )
                                    )
                                  ) +
                                  ") "
                              )
                            ])
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm.juridicalDocumentation.cnpj_certificate
                    ? _c("li", { staticClass: "mb-2 printable-item" }, [
                        _c("i", {
                          staticClass: "feather icon-file",
                          class: _vm.primaryVariant
                            ? "text-" + _vm.primaryVariant
                            : "text-dynamic-primary"
                        }),
                        _vm.getJuridicalDocumentUrl(
                          _vm.juridicalDocumentation.cnpj_certificate
                        )
                          ? _c(
                              "a",
                              {
                                staticClass: "ml-1 no-print download-link",
                                class: _vm.primaryVariant
                                  ? "text-" + _vm.primaryVariant
                                  : "text-dynamic-primary",
                                attrs: {
                                  href: _vm.getJuridicalDocumentUrl(
                                    _vm.juridicalDocumentation.cnpj_certificate
                                  ),
                                  target: "_blank",
                                  title: "Baixar arquivo"
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "feather icon-download"
                                })
                              ]
                            )
                          : _vm._e(),
                        _c("strong", { staticClass: "ml-2" }, [
                          _vm._v("Comprovante de CNPJ:")
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getFileName(
                                _vm.juridicalDocumentation.cnpj_certificate
                              )
                            ) +
                            " "
                        ),
                        _c(
                          "small",
                          {
                            directives: [{ name: "i", rawName: "v-i" }],
                            staticClass: "text-muted ml-2",
                            attrs: {
                              f:
                                "getFileSize(juridicalDocumentation.cnpj_certificate)"
                            }
                          },
                          [
                            _vm._v(
                              " (" +
                                _vm._s(
                                  _vm.formatFileSize(
                                    _vm.getFileSize(
                                      _vm.juridicalDocumentation
                                        .cnpj_certificate
                                    )
                                  )
                                ) +
                                ") "
                            )
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm.juridicalDocumentation.identification_members
                    ? _c("li", { staticClass: "mb-0 printable-item" }, [
                        _c("i", {
                          staticClass: "feather icon-file",
                          class: _vm.primaryVariant
                            ? "text-" + _vm.primaryVariant
                            : "text-dynamic-primary"
                        }),
                        _vm.getJuridicalDocumentUrl(
                          _vm.juridicalDocumentation.identification_members
                        )
                          ? _c(
                              "a",
                              {
                                staticClass: "ml-1 no-print download-link",
                                class: _vm.primaryVariant
                                  ? "text-" + _vm.primaryVariant
                                  : "text-dynamic-primary",
                                attrs: {
                                  href: _vm.getJuridicalDocumentUrl(
                                    _vm.juridicalDocumentation
                                      .identification_members
                                  ),
                                  target: "_blank",
                                  title: "Baixar arquivo"
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "feather icon-download"
                                })
                              ]
                            )
                          : _vm._e(),
                        _c("strong", { staticClass: "ml-2" }, [
                          _vm._v(
                            "Identificação dos integrantes do corpo dirigente de cada instituição:"
                          )
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getFileName(
                                _vm.juridicalDocumentation
                                  .identification_members
                              )
                            ) +
                            " "
                        ),
                        _vm.getFileSize(
                          _vm.juridicalDocumentation.identification_members
                        )
                          ? _c("small", { staticClass: "text-muted ml-2" }, [
                              _vm._v(
                                " (" +
                                  _vm._s(
                                    _vm.formatFileSize(
                                      _vm.getFileSize(
                                        _vm.juridicalDocumentation
                                          .identification_members
                                      )
                                    )
                                  ) +
                                  ") "
                              )
                            ])
                          : _vm._e()
                      ])
                    : _vm._e()
                ])
              ])
            : _c("div", { staticClass: "text-muted printable-item" }, [
                _c("i", { staticClass: "feather icon-alert-triangle mr-2" }),
                _vm._v(" Nenhum documento jurídico foi anexado ainda ")
              ])
        ]
      ),
      _c(
        "b-card",
        {
          staticClass: "mb-3",
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function() {
                return [
                  _c("h6", { staticClass: "mb-0 printable-item" }, [
                    _vm._v("Dados Econômicos e Operacionais")
                  ])
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { md: "6" } }, [
                _c("span", { staticClass: "printable-item" }, [
                  _c("strong", [_vm._v("Período de Referência - Início:")]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.formatDate(
                          _vm.economicOperationalData.certificate_period_start
                        )
                      )
                  )
                ]),
                _c("br"),
                _c("span", { staticClass: "printable-item" }, [
                  _c("strong", [_vm._v("Período de Referência - Fim:")]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.formatDate(
                          _vm.economicOperationalData.certificate_period_end
                        )
                      )
                  )
                ])
              ]),
              _c("b-col", { attrs: { md: "6" } }, [
                _c("span", { staticClass: "printable-item" }, [
                  _c("strong", [_vm._v("Número de Bolsas Ofertadas:")]),
                  _vm._v(
                    " " + _vm._s(_vm.economicOperationalData.scholarship_count)
                  )
                ]),
                _c("br"),
                _c("span", { staticClass: "printable-item" }, [
                  _c("strong", [_vm._v("Tipos de Bolsas:")]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.getScholarshipTypesLabel(
                          _vm.economicOperationalData.scholarship_types
                        )
                      )
                  )
                ])
              ])
            ],
            1
          ),
          _vm.economicOperationalData.support_services
            ? _c("div", { staticClass: "mt-3" }, [
                _c("hr", { staticClass: "my-3" }),
                _c("h6", { staticClass: "text-muted mb-2 printable-item" }, [
                  _vm._v("Serviços de Apoio aos Bolsistas")
                ]),
                _c(
                  "p",
                  { staticClass: "mb-0 printable-item whitespace-pre-wrap" },
                  [_vm._v(_vm._s(_vm.economicOperationalData.support_services))]
                )
              ])
            : _vm._e(),
          _vm.hasEconomicDocuments
            ? _c("div", { staticClass: "mt-3" }, [
                _c("hr", { staticClass: "my-2" }),
                _c("h6", { staticClass: "text-muted mb-2 printable-item" }, [
                  _vm._v("Documentação")
                ]),
                _c("ul", { staticClass: "list-unstyled mb-0" }, [
                  _vm.economicOperationalData.report_activities
                    ? _c("li", { staticClass: "mb-2 printable-item" }, [
                        _c("i", {
                          staticClass: "feather icon-file-text",
                          class: _vm.primaryVariant
                            ? "text-" + _vm.primaryVariant
                            : "text-dynamic-primary"
                        }),
                        _vm.getDownloadUrl(
                          _vm.economicOperationalData.report_activities
                        )
                          ? _c(
                              "a",
                              {
                                staticClass: "ml-1 no-print download-link",
                                class: _vm.primaryVariant
                                  ? "text-" + _vm.primaryVariant
                                  : "text-dynamic-primary",
                                attrs: {
                                  href: _vm.getDownloadUrl(
                                    _vm.economicOperationalData
                                      .report_activities
                                  ),
                                  target: "_blank",
                                  title: "Baixar arquivo"
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "feather icon-download"
                                })
                              ]
                            )
                          : _vm._e(),
                        _c("strong", { staticClass: "ml-2" }, [
                          _vm._v("Relatório de Atividades Desempenhadas:")
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getFileName(
                                _vm.economicOperationalData.report_activities
                              )
                            ) +
                            " "
                        ),
                        _vm.getFileSize(
                          _vm.economicOperationalData.report_activities
                        )
                          ? _c("small", { staticClass: "text-muted ml-2" }, [
                              _vm._v(
                                " (" +
                                  _vm._s(
                                    _vm.formatFileSize(
                                      _vm.getFileSize(
                                        _vm.economicOperationalData
                                          .report_activities
                                      )
                                    )
                                  ) +
                                  ") "
                              )
                            ])
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm.economicOperationalData.summary_report_scholarships
                    ? _c("li", { staticClass: "mb-2 printable-item" }, [
                        _c("i", {
                          staticClass: "feather icon-file-text",
                          class: _vm.primaryVariant
                            ? "text-" + _vm.primaryVariant
                            : "text-dynamic-primary"
                        }),
                        _vm.getDownloadUrl(
                          _vm.economicOperationalData
                            .summary_report_scholarships
                        )
                          ? _c(
                              "a",
                              {
                                staticClass: "ml-1 no-print download-link",
                                class: _vm.primaryVariant
                                  ? "text-" + _vm.primaryVariant
                                  : "text-dynamic-primary",
                                attrs: {
                                  href: _vm.getDownloadUrl(
                                    _vm.economicOperationalData
                                      .summary_report_scholarships
                                  ),
                                  target: "_blank",
                                  title: "Baixar arquivo"
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "feather icon-download"
                                })
                              ]
                            )
                          : _vm._e(),
                        _c("strong", { staticClass: "ml-2" }, [
                          _vm._v("Relatório Sintético de Concessão de Bolsas:")
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getFileName(
                                _vm.economicOperationalData
                                  .summary_report_scholarships
                              )
                            ) +
                            " "
                        ),
                        _vm.getFileSize(
                          _vm.economicOperationalData
                            .summary_report_scholarships
                        )
                          ? _c("small", { staticClass: "text-muted ml-2" }, [
                              _vm._v(
                                " (" +
                                  _vm._s(
                                    _vm.formatFileSize(
                                      _vm.getFileSize(
                                        _vm.economicOperationalData
                                          .summary_report_scholarships
                                      )
                                    )
                                  ) +
                                  ") "
                              )
                            ])
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm.economicOperationalData.list_scholarships
                    ? _c("li", { staticClass: "mb-2 printable-item" }, [
                        _c("i", {
                          staticClass: "feather icon-file-text",
                          class: _vm.primaryVariant
                            ? "text-" + _vm.primaryVariant
                            : "text-dynamic-primary"
                        }),
                        _vm.getDownloadUrl(
                          _vm.economicOperationalData.list_scholarships
                        )
                          ? _c(
                              "a",
                              {
                                staticClass: "ml-1 no-print download-link",
                                class: _vm.primaryVariant
                                  ? "text-" + _vm.primaryVariant
                                  : "text-dynamic-primary",
                                attrs: {
                                  href: _vm.getDownloadUrl(
                                    _vm.economicOperationalData
                                      .list_scholarships
                                  ),
                                  target: "_blank",
                                  title: "Baixar arquivo"
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "feather icon-download"
                                })
                              ]
                            )
                          : _vm._e(),
                        _c("strong", { staticClass: "ml-2" }, [
                          _vm._v("Relação de Bolsas de Estudo:")
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getFileName(
                                _vm.economicOperationalData.list_scholarships
                              )
                            ) +
                            " "
                        ),
                        _vm.getFileSize(
                          _vm.economicOperationalData.list_scholarships
                        )
                          ? _c("small", { staticClass: "text-muted ml-2" }, [
                              _vm._v(
                                " (" +
                                  _vm._s(
                                    _vm.formatFileSize(
                                      _vm.getFileSize(
                                        _vm.economicOperationalData
                                          .list_scholarships
                                      )
                                    )
                                  ) +
                                  ") "
                              )
                            ])
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm.economicOperationalData.analysis_socioeconomic_students
                    ? _c("li", { staticClass: "mb-2 printable-item" }, [
                        _c("i", {
                          staticClass: "feather icon-file-text",
                          class: _vm.primaryVariant
                            ? "text-" + _vm.primaryVariant
                            : "text-dynamic-primary"
                        }),
                        _vm.getDownloadUrl(
                          _vm.economicOperationalData
                            .analysis_socioeconomic_students
                        )
                          ? _c(
                              "a",
                              {
                                staticClass: "ml-1 no-print download-link",
                                class: _vm.primaryVariant
                                  ? "text-" + _vm.primaryVariant
                                  : "text-dynamic-primary",
                                attrs: {
                                  href: _vm.getDownloadUrl(
                                    _vm.economicOperationalData
                                      .analysis_socioeconomic_students
                                  ),
                                  target: "_blank",
                                  title: "Baixar arquivo"
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "feather icon-download"
                                })
                              ]
                            )
                          : _vm._e(),
                        _c("strong", { staticClass: "ml-2" }, [
                          _vm._v(
                            "Análise do Perfil Socioeconômico dos Alunos Bolsistas:"
                          )
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getFileName(
                                _vm.economicOperationalData
                                  .analysis_socioeconomic_students
                              )
                            ) +
                            " "
                        ),
                        _vm.getFileSize(
                          _vm.economicOperationalData
                            .analysis_socioeconomic_students
                        )
                          ? _c("small", { staticClass: "text-muted ml-2" }, [
                              _vm._v(
                                " (" +
                                  _vm._s(
                                    _vm.formatFileSize(
                                      _vm.getFileSize(
                                        _vm.economicOperationalData
                                          .analysis_socioeconomic_students
                                      )
                                    )
                                  ) +
                                  ") "
                              )
                            ])
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm.economicOperationalData.accounting_regime
                    ? _c("li", { staticClass: "mb-2 printable-item" }, [
                        _c("i", {
                          staticClass: "feather icon-file-text",
                          class: _vm.primaryVariant
                            ? "text-" + _vm.primaryVariant
                            : "text-dynamic-primary"
                        }),
                        _vm.getDownloadUrl(
                          _vm.economicOperationalData.accounting_regime
                        )
                          ? _c(
                              "a",
                              {
                                staticClass: "ml-1 no-print download-link",
                                class: _vm.primaryVariant
                                  ? "text-" + _vm.primaryVariant
                                  : "text-dynamic-primary",
                                attrs: {
                                  href: _vm.getDownloadUrl(
                                    _vm.economicOperationalData
                                      .accounting_regime
                                  ),
                                  target: "_blank",
                                  title: "Baixar arquivo"
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "feather icon-download"
                                })
                              ]
                            )
                          : _vm._e(),
                        _c("strong", { staticClass: "ml-2" }, [
                          _vm._v("Regime Contábil:")
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getFileName(
                                _vm.economicOperationalData.accounting_regime
                              )
                            ) +
                            " "
                        ),
                        _vm.getFileSize(
                          _vm.economicOperationalData.accounting_regime
                        )
                          ? _c("small", { staticClass: "text-muted ml-2" }, [
                              _vm._v(
                                " (" +
                                  _vm._s(
                                    _vm.formatFileSize(
                                      _vm.getFileSize(
                                        _vm.economicOperationalData
                                          .accounting_regime
                                      )
                                    )
                                  ) +
                                  ") "
                              )
                            ])
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm.economicOperationalData.accounting_reports
                    ? _c("li", { staticClass: "mb-2 printable-item" }, [
                        _c("i", {
                          staticClass: "feather icon-file-text",
                          class: _vm.primaryVariant
                            ? "text-" + _vm.primaryVariant
                            : "text-dynamic-primary"
                        }),
                        _vm.getDownloadUrl(
                          _vm.economicOperationalData.accounting_reports
                        )
                          ? _c(
                              "a",
                              {
                                staticClass: "ml-1 no-print download-link",
                                class: _vm.primaryVariant
                                  ? "text-" + _vm.primaryVariant
                                  : "text-dynamic-primary",
                                attrs: {
                                  href: _vm.getDownloadUrl(
                                    _vm.economicOperationalData
                                      .accounting_reports
                                  ),
                                  target: "_blank",
                                  title: "Baixar arquivo"
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "feather icon-download"
                                })
                              ]
                            )
                          : _vm._e(),
                        _c("strong", { staticClass: "ml-2" }, [
                          _vm._v("Relatórios Contábeis:")
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getFileName(
                                _vm.economicOperationalData.accounting_reports
                              )
                            ) +
                            " "
                        ),
                        _vm.getFileSize(
                          _vm.economicOperationalData.accounting_reports
                        )
                          ? _c("small", { staticClass: "text-muted ml-2" }, [
                              _vm._v(
                                " (" +
                                  _vm._s(
                                    _vm.formatFileSize(
                                      _vm.getFileSize(
                                        _vm.economicOperationalData
                                          .accounting_reports
                                      )
                                    )
                                  ) +
                                  ") "
                              )
                            ])
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm.economicOperationalData.accounting_gratuity_demo
                    ? _c("li", { staticClass: "mb-2 printable-item" }, [
                        _c("i", {
                          staticClass: "feather icon-file-text",
                          class: _vm.primaryVariant
                            ? "text-" + _vm.primaryVariant
                            : "text-dynamic-primary"
                        }),
                        _vm.getDownloadUrl(
                          _vm.economicOperationalData.accounting_gratuity_demo
                        )
                          ? _c(
                              "a",
                              {
                                staticClass: "ml-1 no-print download-link",
                                class: _vm.primaryVariant
                                  ? "text-" + _vm.primaryVariant
                                  : "text-dynamic-primary",
                                attrs: {
                                  href: _vm.getDownloadUrl(
                                    _vm.economicOperationalData
                                      .accounting_gratuity_demo
                                  ),
                                  target: "_blank",
                                  title: "Baixar arquivo"
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "feather icon-download"
                                })
                              ]
                            )
                          : _vm._e(),
                        _c("strong", { staticClass: "ml-2" }, [
                          _vm._v("Demonstração Contábil da Gratuidade:")
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getFileName(
                                _vm.economicOperationalData
                                  .accounting_gratuity_demo
                              )
                            ) +
                            " "
                        ),
                        _vm.getFileSize(
                          _vm.economicOperationalData.accounting_gratuity_demo
                        )
                          ? _c("small", { staticClass: "text-muted ml-2" }, [
                              _vm._v(
                                " (" +
                                  _vm._s(
                                    _vm.formatFileSize(
                                      _vm.getFileSize(
                                        _vm.economicOperationalData
                                          .accounting_gratuity_demo
                                      )
                                    )
                                  ) +
                                  ") "
                              )
                            ])
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm.economicOperationalData.audit_opinion
                    ? _c("li", { staticClass: "mb-2 printable-item" }, [
                        _c("i", {
                          staticClass: "feather icon-file-text",
                          class: _vm.primaryVariant
                            ? "text-" + _vm.primaryVariant
                            : "text-dynamic-primary"
                        }),
                        _vm.getDownloadUrl(
                          _vm.economicOperationalData.audit_opinion
                        )
                          ? _c(
                              "a",
                              {
                                staticClass: "ml-1 no-print download-link",
                                class: _vm.primaryVariant
                                  ? "text-" + _vm.primaryVariant
                                  : "text-dynamic-primary",
                                attrs: {
                                  href: _vm.getDownloadUrl(
                                    _vm.economicOperationalData.audit_opinion
                                  ),
                                  target: "_blank",
                                  title: "Baixar arquivo"
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "feather icon-download"
                                })
                              ]
                            )
                          : _vm._e(),
                        _c("strong", { staticClass: "ml-2" }, [
                          _vm._v(
                            "Parecer de Auditoria Independente do Exercício em Análise:"
                          )
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getFileName(
                                _vm.economicOperationalData.audit_opinion
                              )
                            ) +
                            " "
                        ),
                        _vm.getFileSize(
                          _vm.economicOperationalData.audit_opinion
                        )
                          ? _c("small", { staticClass: "text-muted ml-2" }, [
                              _vm._v(
                                " (" +
                                  _vm._s(
                                    _vm.formatFileSize(
                                      _vm.getFileSize(
                                        _vm.economicOperationalData
                                          .audit_opinion
                                      )
                                    )
                                  ) +
                                  ") "
                              )
                            ])
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm.economicOperationalData.revenue_received
                    ? _c("li", { staticClass: "mb-0 printable-item" }, [
                        _c("i", {
                          staticClass: "feather icon-file-text",
                          class: _vm.primaryVariant
                            ? "text-" + _vm.primaryVariant
                            : "text-dynamic-primary"
                        }),
                        _vm.getDownloadUrl(
                          _vm.economicOperationalData.revenue_received
                        )
                          ? _c(
                              "a",
                              {
                                staticClass: "ml-1 no-print download-link",
                                class: _vm.primaryVariant
                                  ? "text-" + _vm.primaryVariant
                                  : "text-dynamic-primary",
                                attrs: {
                                  href: _vm.getDownloadUrl(
                                    _vm.economicOperationalData.revenue_received
                                  ),
                                  target: "_blank",
                                  title: "Baixar arquivo"
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "feather icon-download"
                                })
                              ]
                            )
                          : _vm._e(),
                        _c("strong", { staticClass: "ml-2" }, [
                          _vm._v("Receita Efetivamente Recebida:")
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getFileName(
                                _vm.economicOperationalData.revenue_received
                              )
                            ) +
                            " "
                        ),
                        _vm.getFileSize(
                          _vm.economicOperationalData.revenue_received
                        )
                          ? _c("small", { staticClass: "text-muted ml-2" }, [
                              _vm._v(
                                " (" +
                                  _vm._s(
                                    _vm.formatFileSize(
                                      _vm.getFileSize(
                                        _vm.economicOperationalData
                                          .revenue_received
                                      )
                                    )
                                  ) +
                                  ") "
                              )
                            ])
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm.economicOperationalData.service_plan
                    ? _c("li", { staticClass: "mb-0 printable-item" }, [
                        _c("i", {
                          staticClass: "feather icon-file-text",
                          class: _vm.primaryVariant
                            ? "text-" + _vm.primaryVariant
                            : "text-dynamic-primary"
                        }),
                        _vm.getDownloadUrl(
                          _vm.economicOperationalData.service_plan
                        )
                          ? _c(
                              "a",
                              {
                                staticClass: "ml-1 no-print download-link",
                                class: _vm.primaryVariant
                                  ? "text-" + _vm.primaryVariant
                                  : "text-dynamic-primary",
                                attrs: {
                                  href: _vm.getDownloadUrl(
                                    _vm.economicOperationalData.service_plan
                                  ),
                                  target: "_blank",
                                  title: "Baixar arquivo"
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "feather icon-download"
                                })
                              ]
                            )
                          : _vm._e(),
                        _c("strong", { staticClass: "ml-2" }, [
                          _vm._v("Plano de Atendimento:")
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getFileName(
                                _vm.economicOperationalData.service_plan
                              )
                            ) +
                            " "
                        ),
                        _vm.getFileSize(
                          _vm.economicOperationalData.service_plan
                        )
                          ? _c("small", { staticClass: "text-muted ml-2" }, [
                              _vm._v(
                                " (" +
                                  _vm._s(
                                    _vm.formatFileSize(
                                      _vm.getFileSize(
                                        _vm.economicOperationalData.service_plan
                                      )
                                    )
                                  ) +
                                  ") "
                              )
                            ])
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm.economicOperationalData.social_assistance_registration
                    ? _c("li", { staticClass: "mb-0 printable-item" }, [
                        _c("i", {
                          staticClass: "feather icon-file-text",
                          class: _vm.primaryVariant
                            ? "text-" + _vm.primaryVariant
                            : "text-dynamic-primary"
                        }),
                        _vm.getDownloadUrl(
                          _vm.economicOperationalData
                            .social_assistance_registration
                        )
                          ? _c(
                              "a",
                              {
                                staticClass: "ml-1 no-print download-link",
                                class: _vm.primaryVariant
                                  ? "text-" + _vm.primaryVariant
                                  : "text-dynamic-primary",
                                attrs: {
                                  href: _vm.getDownloadUrl(
                                    _vm.economicOperationalData
                                      .social_assistance_registration
                                  ),
                                  target: "_blank",
                                  title: "Baixar arquivo"
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "feather icon-download"
                                })
                              ]
                            )
                          : _vm._e(),
                        _c("strong", { staticClass: "ml-2" }, [
                          _vm._v("Inscrição dos Serviços Socioassistenciais:")
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getFileName(
                                _vm.economicOperationalData
                                  .social_assistance_registration
                              )
                            ) +
                            " "
                        ),
                        _vm.getFileSize(
                          _vm.economicOperationalData
                            .social_assistance_registration
                        )
                          ? _c("small", { staticClass: "text-muted ml-2" }, [
                              _vm._v(
                                " (" +
                                  _vm._s(
                                    _vm.formatFileSize(
                                      _vm.getFileSize(
                                        _vm.economicOperationalData
                                          .social_assistance_registration
                                      )
                                    )
                                  ) +
                                  ") "
                              )
                            ])
                          : _vm._e()
                      ])
                    : _vm._e()
                ])
              ])
            : _c("div", { staticClass: "mt-3" }, [
                _c("hr", { staticClass: "my-2" }),
                _c("h6", { staticClass: "text-muted mb-2 printable-item" }, [
                  _vm._v("Documentação")
                ]),
                _c("div", { staticClass: "text-muted printable-item" }, [
                  _c("i", { staticClass: "feather icon-alert-triangle mr-2" }),
                  _vm._v(" Nenhum documento foi anexado ainda ")
                ])
              ])
        ],
        1
      ),
      _c(
        "b-card",
        {
          staticClass: "mb-3",
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function() {
                return [
                  _c("h6", { staticClass: "mb-0 printable-item" }, [
                    _vm._v("Unidades Vinculadas")
                  ])
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _vm.hasLinkedInstitutions
            ? _c(
                "div",
                _vm._l(_vm.linkedInstitutions, function(institution, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "mb-4" },
                    [
                      index > 0
                        ? _c("div", { staticClass: "hr-divider my-3" }, [
                            _c("hr")
                          ])
                        : _vm._e(),
                      _c(
                        "h6",
                        { staticClass: "text-muted mb-2 printable-item" },
                        [
                          _c("i", {
                            staticClass: "feather icon-building mr-2"
                          }),
                          _vm._v(" Unidade " + _vm._s(index + 1) + " ")
                        ]
                      ),
                      _c(
                        "b-row",
                        [
                          institution.institution_name
                            ? _c("b-col", { attrs: { md: "12" } }, [
                                _c("span", { staticClass: "printable-item" }, [
                                  _c("strong", [
                                    _vm._v("Nome da Instituição:")
                                  ]),
                                  _vm._v(
                                    " " + _vm._s(institution.institution_name)
                                  )
                                ]),
                                _c("br")
                              ])
                            : _vm._e(),
                          institution.institution_cnpj
                            ? _c("b-col", { attrs: { md: "6" } }, [
                                _c("span", { staticClass: "printable-item" }, [
                                  _c("strong", [_vm._v("CNPJ:")]),
                                  _vm._v(
                                    " " + _vm._s(institution.institution_cnpj)
                                  )
                                ]),
                                _c("br")
                              ])
                            : _vm._e(),
                          institution.city_name ||
                          institution.state_name ||
                          institution.state_short
                            ? _c("b-col", { attrs: { md: "6" } }, [
                                _c("span", { staticClass: "printable-item" }, [
                                  _c("strong", [_vm._v("Localização:")]),
                                  _vm._v(
                                    " " +
                                      _vm._s(institution.city_name || "") +
                                      _vm._s(
                                        institution.city_name &&
                                          (institution.state_short ||
                                            institution.state_name)
                                          ? ", "
                                          : ""
                                      ) +
                                      _vm._s(
                                        institution.state_short ||
                                          institution.state_name ||
                                          ""
                                      )
                                  )
                                ]),
                                _c("br")
                              ])
                            : _vm._e()
                        ],
                        1
                      ),
                      institution.institution_authorization ||
                      institution.school_regulations
                        ? _c("div", { staticClass: "mt-3" }, [
                            _c("hr", { staticClass: "my-2" }),
                            _c(
                              "h6",
                              { staticClass: "text-muted mb-2 printable-item" },
                              [_vm._v("Documentação")]
                            ),
                            _c("ul", { staticClass: "list-unstyled mb-0" }, [
                              institution.institution_authorization
                                ? _c(
                                    "li",
                                    { staticClass: "mb-2 printable-item" },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "feather icon-file-text text-primary mr-2"
                                      }),
                                      _vm.getDownloadUrl(
                                        institution.institution_authorization
                                      )
                                        ? _c(
                                            "a",
                                            {
                                              staticClass:
                                                "mr-1 no-print download-link",
                                              class: _vm.primaryVariant
                                                ? "text-" + _vm.primaryVariant
                                                : "text-dynamic-primary",
                                              attrs: {
                                                href: _vm.getDownloadUrl(
                                                  institution.institution_authorization
                                                ),
                                                target: "_blank",
                                                title: "Baixar arquivo"
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "feather icon-download"
                                              })
                                            ]
                                          )
                                        : _vm._e(),
                                      _c("strong", [
                                        _vm._v(
                                          "Atos de Credenciamento/Autorização:"
                                        )
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getFileName(
                                              institution.institution_authorization
                                            )
                                          ) +
                                          " "
                                      ),
                                      _vm.getFileSize(
                                        institution.institution_authorization
                                      )
                                        ? _c(
                                            "small",
                                            { staticClass: "text-muted ml-2" },
                                            [
                                              _vm._v(
                                                " (" +
                                                  _vm._s(
                                                    _vm.formatFileSize(
                                                      _vm.getFileSize(
                                                        institution.institution_authorization
                                                      )
                                                    )
                                                  ) +
                                                  ") "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                : _vm._e(),
                              institution.school_regulations
                                ? _c(
                                    "li",
                                    { staticClass: "mb-2 printable-item" },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "feather icon-file-text text-primary mr-2"
                                      }),
                                      _vm.getDownloadUrl(
                                        institution.school_regulations
                                      )
                                        ? _c(
                                            "a",
                                            {
                                              staticClass:
                                                "mr-1 no-print download-link",
                                              class: _vm.primaryVariant
                                                ? "text-" + _vm.primaryVariant
                                                : "text-dynamic-primary",
                                              attrs: {
                                                href: _vm.getDownloadUrl(
                                                  institution.school_regulations
                                                ),
                                                target: "_blank",
                                                title: "Baixar arquivo"
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "feather icon-download"
                                              })
                                            ]
                                          )
                                        : _vm._e(),
                                      _c("strong", [
                                        _vm._v("Regimento Interno ou Estatuto:")
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getFileName(
                                              institution.school_regulations
                                            )
                                          ) +
                                          " "
                                      ),
                                      _vm.getFileSize(
                                        institution.school_regulations
                                      )
                                        ? _c(
                                            "small",
                                            { staticClass: "text-muted ml-2" },
                                            [
                                              _vm._v(
                                                " (" +
                                                  _vm._s(
                                                    _vm.formatFileSize(
                                                      _vm.getFileSize(
                                                        institution.school_regulations
                                                      )
                                                    )
                                                  ) +
                                                  ") "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                }),
                0
              )
            : _c("div", { staticClass: "text-muted printable-item" }, [
                _c("i", { staticClass: "feather icon-alert-triangle mr-2" }),
                _vm._v(" Nenhuma unidade vinculada foi informada ainda ")
              ])
        ]
      ),
      _c(
        "b-card",
        {
          staticClass: "mb-3",
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function() {
                return [
                  _c("h6", { staticClass: "mb-0 printable-item" }, [
                    _vm._v("Anexos Complementares")
                  ])
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _vm.hasAdditionalAttachments
            ? _c("div", [
                _c("p", { staticClass: "text-muted mb-3 printable-item" }, [
                  _c("i", { staticClass: "feather icon-paperclip mr-1" }),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.additionalAttachments.additional_attachments.length
                      ) +
                      " anexo(s) complementar(es) "
                  )
                ]),
                _c(
                  "ul",
                  { staticClass: "list-unstyled mb-0" },
                  _vm._l(
                    _vm.additionalAttachments.additional_attachments,
                    function(file, index) {
                      return _c(
                        "li",
                        { key: index, staticClass: "mb-2 printable-item" },
                        [
                          _c("i", {
                            staticClass: "mr-2",
                            class: _vm.getFileIcon(_vm.getFileName(file))
                          }),
                          _vm.getAttachmentUrl(file)
                            ? _c(
                                "a",
                                {
                                  staticClass: "mr-2 no-print download-link",
                                  class: _vm.primaryVariant
                                    ? "text-" + _vm.primaryVariant
                                    : "text-dynamic-primary",
                                  attrs: {
                                    href: _vm.getAttachmentUrl(file),
                                    target: "_blank",
                                    title: "Baixar arquivo"
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "feather icon-download"
                                  })
                                ]
                              )
                            : _vm._e(),
                          _c("strong", [_vm._v(_vm._s(_vm.getFileName(file)))]),
                          _c("small", { staticClass: "text-muted ml-2" }, [
                            _vm._v(
                              "(" +
                                _vm._s(
                                  _vm.formatFileSize(_vm.getFileSize(file))
                                ) +
                                ")"
                            )
                          ])
                        ]
                      )
                    }
                  ),
                  0
                )
              ])
            : _c("div", { staticClass: "text-muted printable-item" }, [
                _c("i", { staticClass: "feather icon-info mr-2" }),
                _vm._v(" Nenhum anexo complementar foi adicionado (opcional) ")
              ])
        ]
      ),
      !_vm.disabled
        ? _c(
            "b-form-group",
            { staticClass: "mt-4" },
            [
              _c(
                "b-form-checkbox",
                {
                  class: !_vm.primaryVariant ? "checkbox-dynamic-primary" : "",
                  attrs: {
                    checked: _vm.acceptTerms,
                    state: _vm.getFieldState("acceptTerms")
                  },
                  on: {
                    change: function($event) {
                      return _vm.$emit("update:accept-terms", $event)
                    }
                  }
                },
                [
                  _vm._v(
                    " Declaro que todas as informações fornecidas são verdadeiras e aceito os "
                  ),
                  _c(
                    "b-link",
                    {
                      class: _vm.primaryVariant
                        ? "text-" + _vm.primaryVariant
                        : "text-dynamic-primary",
                      attrs: { href: "#" },
                      on: {
                        click: function($event) {
                          return _vm.$emit("show-terms")
                        }
                      }
                    },
                    [_vm._v(" termos e condições ")]
                  ),
                  _vm._v(". ")
                ],
                1
              ),
              _c("b-form-invalid-feedback", [
                _vm._v(" Você deve aceitar os termos e condições ")
              ])
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass:
            "print-button-container text-center mt-4 no-print cursor-pointer"
        },
        [
          _c(
            "b-button",
            {
              staticClass: "mr-1",
              class: !_vm.primaryVariant ? "btn-dynamic-primary" : "",
              attrs: { variant: _vm.primaryVariant || "primary", size: "lg" },
              on: { click: _vm.printPage }
            },
            [
              _c("i", { staticClass: "feather icon-printer mr-1" }),
              _vm._v(" Imprimir Revisão ")
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }